// extracted by mini-css-extract-plugin
var _1 = "AuthenticationSettings_action__mZdM-";
var _2 = "AuthenticationSettings_actionsWrapper__a2OPq";
var _3 = "AuthenticationSettings_apiClientCount__V1utR";
var _4 = "AuthenticationSettings_apiClientsHeader__MRZQO";
var _5 = "AuthenticationSettings_copyButton__WudvT";
var _6 = "AuthenticationSettings_createdAt__AEdKV";
var _7 = "AuthenticationSettings_data__ydc2v";
var _8 = "AuthenticationSettings_dataPermissions__vI9aA";
var _9 = "AuthenticationSettings_dataWrapper__F932-";
var _a = "AuthenticationSettings_item__pkb+S";
var _b = "AuthenticationSettings_itemContent__XOZ9A";
var _c = "AuthenticationSettings_itemHeader__1rkGg";
var _d = "AuthenticationSettings_itemHeaderButtons__mnPZi";
var _e = "AuthenticationSettings_items__nQI8H";
var _f = "AuthenticationSettings_lastUsed__YsUsz";
var _10 = "AuthenticationSettings_noApiClients__wFnI0";
export { _1 as "action", _2 as "actionsWrapper", _3 as "apiClientCount", _4 as "apiClientsHeader", _5 as "copyButton", _6 as "createdAt", _7 as "data", _8 as "dataPermissions", _9 as "dataWrapper", _a as "item", _b as "itemContent", _c as "itemHeader", _d as "itemHeaderButtons", _e as "items", _f as "lastUsed", _10 as "noApiClients" }
